<template>
  <v-container id="payment-monitor" class="px-6">
      <v-row>
        <v-col class="pt-1 pb-5" cols="12">
          <h1>Monitor de Recebíveis
            <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn 
                          color="primary" 
                          icon
                          small
                          @click=modalVideo()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Acesso ao recebíveis</span>
                        </v-tooltip>
                  </span>
          </h1>
        </v-col>
        <v-col class="pt-1 pb-5" cols="12">
        <FilterByPrestadorOperadora :filter="(filter)=>getDashboard(filter)" :filtrarPorCarteiras="filtrarPorCarteiras"/>
        </v-col>
        <v-col class="pa-0" cols="6">
          <v-col class="py-2">
            <v-card outlined v-if="cadastro_logins_operadoras">
              <v-card-title class="pt-2 pb-3">
                <b>Cadastro de Logins por Operadoras
                  <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=modalVideoCadastro()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Como editar acesso ao portal das operadoras</span>
                        </v-tooltip>
                  </span>
                </b> 
              </v-card-title>
              <v-card-text class="py-0">
                <v-row>
                  <v-col class="pt-1 text-center" cols="4">
                    <b style="font-size:16px">{{cadastro_logins_operadoras.qtd_logins_cadastrados}}</b>
                    <div class="title-text pt-1">
                      LOGINS <br> CADASTRADOS
                    </div>
                  </v-col>
                  <v-col class="pt-1 text-center" cols="4">
                    <b style="font-size:16px">{{cadastro_logins_operadoras.qtd_operadoras_monitoradas}}</b>
                    <div class="title-text pt-1">
                      OPERADORAS <br> MONITORADAS
                    </div>
                  </v-col>
                  <v-col class="pt-0 text-center" cols="4">
                    <b style="font-size:16px;color:#D0021B">{{cadastro_logins_operadoras.qtd_logins_invalidos}}</b>
                    <v-btn @click="setFilter('identNaOperadoraFilter')" class="pb-1" small color="primary" icon>
                      <v-icon small>fas fa-external-link-alt</v-icon>
                    </v-btn>
                    <div class="title-text">
                      LOGINS <br> INVÁLIDOS
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="py-2">
            <v-card outlined v-if="monitoramento_pagamento">
              <v-card-title class="pb-0 pt-2">
                <b>Processos de Identificação de Pagamentos
                  <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=modalVideoProcessos()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Acompanhamento do monitoramento operadoras</span>
                        </v-tooltip>
                  </span>
                </b>
                <v-spacer></v-spacer>
                <span class="title-text text-right" v-if="monitoramento_pagamento.dt_ultima_posicao">
                  Última posição: <br>
                  {{ monitoramento_pagamento.dt_ultima_posicao | formatDate }}
                </span>
              </v-card-title>
              <v-card-text class="py-0">
                <div class="title-text">
                  <b style="font-size:14px">{{ monitoramento_pagamento.qtd_processos_em_aberto }}</b> PROCESSOS EM ABERTO / <b style="font-size:14px">{{ monitoramento_pagamento.qtd_operadoras }}</b> OPERADORAS
                </div>
                <v-row>
                  <v-col class="pt-3 text-center" cols="4">
                    <b style="font-size:16px">{{ monitoramento_pagamento.qtd_executados_hoje }}</b>
                    <v-btn @click="setFilter('identPagamentosFilter', {status:'executado', hoje: true})" class="pb-1" small color="primary" icon>
                      <v-icon small>fas fa-external-link-alt</v-icon>
                    </v-btn>
                    <div class="title-text pt-1">
                      EXECUTADOS HOJE
                    </div>
                  </v-col>
                  <v-col class="pt-3 text-center" cols="4">
                    <b style="font-size:16px;color:#fc9e0d">{{ monitoramento_pagamento.qtd_em_execucao }}</b>
                    <v-btn @click="setFilter('identPagamentosFilter', {status:'em_execucao'})" class="pb-1" small color="primary" icon>
                      <v-icon small>fas fa-external-link-alt</v-icon>
                    </v-btn>
                    <div class="title-text pt-1">
                      EM EXECUÇÃO
                    </div>
                  </v-col>
                  <v-col class="pt-2 text-center" cols="4">
                    <b style="font-size:16px;color:#D0021B">{{ monitoramento_pagamento.qtd_com_intercorrencias }}</b>
                    <v-btn @click="setFilter('identPagamentosFilter', {status:'com_intercorrencia'})" class="pb-1" small color="primary" icon>
                      <v-icon small>fas fa-external-link-alt</v-icon>
                    </v-btn>
                    <div class="title-text">
                      COM INTERCORRÊNCIAS
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="py-2">
          <v-card outlined v-if="pagamentos_processamento">
            <v-card-title class="pb-0 pt-2">
              <b>Pagamentos em processamento</b> 
              <v-btn @click="setFilter('pagamentosEmProcessamento',{qtd_dias: null})" small color="primary" icon>
                <v-icon small>fas fa-external-link-alt</v-icon>
              </v-btn>
              <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=modalVideoPagamentos()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Pagamentos em Processamento</span>
                        </v-tooltip>
                  </span>
              <v-spacer></v-spacer>
              <span class="title-text" v-if="pagamentos_processamento.dt_ultima_posicao">
                  Última posição: <br>
                  {{pagamentos_processamento.dt_ultima_posicao | formatDate}}
              </span>
            </v-card-title>
            <v-card-text class="py-0">
              <div class="title-text">
                <b style="font-size:14px">{{pagamentos_processamento.qtd_pagamentos}}</b> PAGAMENTOS / <b style="font-size:16px;color:#D0021B">{{pagamentos_processamento.qtd_intercorrencias}}</b> INTERCORRÊNCIAS 
              </div>
              <v-row>
                <v-col class="text-center" cols="4">
                  <b style="font-size:16px;color:#fc9e0d">{{pagamentos_processamento.d3.qtd_pagamentos}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d3.perc_pagamentos}}%)</span>
                  <v-btn @click="setFilter('pagamentosEmProcessamento', {qtd_dias: 3})" small color="primary" icon>
                    <v-icon small>fas fa-external-link-alt</v-icon>
                  </v-btn>
                  <div class="title-text pb-1">
                    D3 
                  </div>
                  <b style="font-size:16px">R$ {{pagamentos_processamento.d3.valor_pagamento_estimado | formatPrice}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d3.perc_valor_pagamento_estimado}}%)</span>
                  <div class="title-text pt-1 pb-1">
                    PAGAMENTO ESTIMADO
                  </div>
                  <b style="font-size:16px;color:#D0021B">R$ {{pagamentos_processamento.d3.valor_glosa_estimada | formatPrice}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d3.perc_valor_glosa_estimada}}%)</span>
                  <div class="title-text pt-1 pb-1">
                    GLOSA ESTIMADA 
                  </div>
                </v-col>
                <v-col class="text-center" cols="4">
                  <b style="font-size:16px;color:#fc9e0d">{{pagamentos_processamento.d5.qtd_pagamentos}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d5.perc_pagamentos}}%)</span>
                  <v-btn @click="setFilter('pagamentosEmProcessamento', {qtd_dias: 5})" small color="primary" icon>
                    <v-icon small>fas fa-external-link-alt</v-icon>
                  </v-btn>
                  <div class="title-text pb-1">
                    D5
                  </div>
                  <b style="font-size:16px">R$ {{pagamentos_processamento.d5.valor_pagamento_estimado | formatPrice}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d5.perc_valor_pagamento_estimado}}%)</span>
                  <div class="title-text pt-1 pb-1">
                    PAGAMENTO ESTIMADO
                  </div>
                  <b style="font-size:16px;color:#D0021B">R$ {{pagamentos_processamento.d5.valor_glosa_estimada | formatPrice}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d5.perc_valor_glosa_estimada}}%)</span>
                  <div class="title-text pt-1 pb-1">
                    GLOSA ESTIMADA 
                  </div>
                </v-col>
                <v-col class="text-center" cols="4">
                  <b style="font-size:16px;color:#fc9e0d">{{pagamentos_processamento.d6.qtd_pagamentos}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d6.perc_pagamentos}}%)</span>
                  <v-btn @click="setFilter('pagamentosEmProcessamento', {qtd_dias: 6})" small color="primary" icon>
                    <v-icon small>fas fa-external-link-alt</v-icon>
                  </v-btn>
                  <div class="title-text pb-1">
                    D>5 
                  </div>
                  <b style="font-size:16px">R$ {{pagamentos_processamento.d6.valor_pagamento_estimado | formatPrice}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d6.perc_valor_pagamento_estimado}}%)</span>
                  <div class="title-text pt-1 pb-1">
                    PAGAMENTO ESTIMADO
                  </div>
                  <b style="font-size:16px;color:#D0021B">R$ {{pagamentos_processamento.d6.valor_glosa_estimada | formatPrice}}</b><span class="title-text pb-1 ml-1">({{pagamentos_processamento.d6.perc_valor_glosa_estimada}}%)</span>
                  <div class="title-text pt-1 pb-1">
                    GLOSA ESTIMADA 
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        </v-col>
        <v-col class="pa-0" cols="6">
        <v-col class="py-2">
            <v-card outlined v-if="publicados_mes_corrente">
              <v-card-title class="pb-0 pt-2">
                <b>Publicados no mês corrente</b> 
                <v-btn @click="setFilter('pagamentosPublicados', {status: null, mes_corrente: true})" small color="primary" icon>
                <v-icon small>fas fa-external-link-alt</v-icon>
              </v-btn>
              <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=modalVideoPubliados()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Publicados no mês corrente: entenda os tipos de arquivos</span>
                        </v-tooltip>
                  </span>
                <v-spacer></v-spacer>
                <span class="title-text">
                  {{publicados_mes_corrente.mes_corrente}}
                </span>
              </v-card-title>
              <v-card-text class="py-0">
                <div class="title-text pb-1">
                  <b style="font-size:14px">{{publicados_mes_corrente.qtd_pagamentos}}</b> PAGAMENTOS / <b style="font-size:14px">{{publicados_mes_corrente.qtd_operadoras}}</b> OPERADORAS
                </div>
                <v-row>
                  <v-col class="text-center pt-3" cols="4">
                    <b style="font-size:16px">R$ {{publicados_mes_corrente.valor_processado | formatPrice}}</b>
                    <div class="title-text pt-1">
                      PROCESSADO
                    </div>
                  </v-col>
                  <v-col class="text-center pt-3" cols="4">
                    <b style="font-size:16px; color: #32b88b">R$ {{publicados_mes_corrente.valor_pago | formatPrice}}</b>
                    <div class="title-text pt-1">
                      PAGO
                    </div>
                  </v-col>
                  <v-col class="text-center pt-3" cols="4">
                    <b style="font-size:16px;color:#D0021B">R$ {{publicados_mes_corrente.valor_glosado | formatPrice}}</b>
                    <div class="title-text pt-1">
                      GLOSADO
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="py-2">
            <v-card outlined v-if="aguardando_quitacao">
              <v-card-title class="pb-0 pt-2">
                <b>Aguardando quitação</b>
                <v-btn @click="setFilter('pagamentosPublicados', {status: false, mes_corrente: false})" small color="primary" icon>
                  <v-icon small>fas fa-external-link-alt</v-icon>
                </v-btn>
                <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=modalVideoQuitar()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Como quitar o pagamento</span>
                        </v-tooltip>
                  </span>
                <v-spacer></v-spacer>
                <span class="title-text" v-if="aguardando_quitacao.dt_ultima_posicao">
                  Última posição: <br>
                  {{aguardando_quitacao.dt_ultima_posicao | formatDate}}
                </span>
              </v-card-title>
              <v-card-text class="pt-0 pb-3">
                <div class="title-text">
                  <b style="font-size:14px">{{aguardando_quitacao.qtd_pagamentos}}</b> PAGAMENTOS / <b style="font-size:14px">{{aguardando_quitacao.qtd_operadoras}}</b> OPERADORAS
                </div>
                <v-row>
                  <v-col class="text-center pt-3" cols="4">
                    <b style="font-size:16px">R$ {{aguardando_quitacao.valor_processado | formatPrice}}</b>
                    <div class="title-text pt-1">
                      PROCESSADO
                    </div>
                  </v-col>
                  <v-col class="text-center pt-3" cols="4">
                    <b style="font-size:16px; color: #32b88b">R$ {{aguardando_quitacao.valor_pago | formatPrice}}</b>
                    <div class="title-text pt-1">
                      PAGO
                    </div>
                  </v-col>
                  <v-col class="text-center pt-3" cols="4">
                    <b style="font-size:16px;color:#D0021B">R$ {{aguardando_quitacao.valor_glosado | formatPrice}}</b>
                    <div class="title-text pt-1">
                      GLOSADO
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="py-2">
          <v-card outlined style="min-height:207px" v-if="recurso_glosa">
            <v-card-title class="pb-0 pt-2">
              <b>Recurso de Glosa</b>
              <v-btn  @click="setFilter('monitorGlosaFilter')" small color="primary" icon>
                <v-icon small>fas fa-external-link-alt</v-icon>
              </v-btn>
              <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary" 
                          icon
                          small
                          @click=modalVideoGlosa()
                          v-bind="attrs"
                          v-on="on"  
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Ajuda: Recurso de glosa: tipos de envios e status</span>
                        </v-tooltip>
                  </span>
              <v-spacer></v-spacer>
                <span class="title-text" v-if="recurso_glosa.dt_ultima_posicao">
                  Última posição: <br>
                  {{recurso_glosa.dt_ultima_posicao | formatDate}}
                </span>
            </v-card-title>
            <v-card-text class="pt-0 pb-3">
              <div class="title-text">
                <b style="font-size:14px">{{recurso_glosa.qtd_pagamentos}}</b> PAGAMENTOS / <b style="font-size:14px">{{recurso_glosa.qtd_operadoras}}</b> OPERADORAS  
              </div>
              <v-row>
                <v-col class="text-center pt-4" cols="12">
                  <b style="font-size:16px;color:#D0021B">R$ {{recurso_glosa.total_glosado | formatPrice}}</b>
                  <div class="title-text pt-1 pb-0">
                    TOTAL GLOSADO
                  </div>
                </v-col>
                <v-col class="text-center" cols="6">
                  <b style="font-size:16px">R$ {{ recurso_glosa.em_execucao | formatPrice}}</b>
                  <div class="title-text pt-1 pb-3">
                    EM EXECUÇÃO
                  </div>
                </v-col>
                <v-col class="text-center pb-4" cols="6">
                  <b style="font-size:16px;color:#fc9e0d">R$ {{recurso_glosa.nao_iniciado | formatPrice}}</b>
                  <div class="title-text pt-1 pb-3">
                    NÃO INICIADO 
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        </v-col>
      
      </v-row>
  </v-container>
</template>

<script>
import FilterByPrestadorOperadora from "@/components/common/FilterByPrestadorOperadora"
export default {
  components:{
    FilterByPrestadorOperadora
  },
  data() {
    return {
        aguardando_quitacao: null,
        cards: ['cadastro_logins_operadoras', 'monitoramento_pagamento', 'pagamentos_processamento', 'publicados_mes_corrente', 'aguardando_quitacao', 'recurso_glosa'],
        cadastro_logins_operadoras: null,
        filtrarPorCarteiras: false,
        monitoramento_pagamento: null,
        pagamentos_processamento: null,
        publicados_mes_corrente: null,
        recurso_glosa: null,
    }
  },
  mounted() {
     this.temPermissaoCarteira()
  },
  methods: {
    setFilter(card, opcoes){
      let filter = {
        filterData: {
          ...this.filter,
          ...opcoes,
        },
        filterName: card,
        redirect: true
      }
      switch (card) {
        case 'identPagamentosFilter':
          filter.filterData.dt_inicio = null
          filter.filterData.dt_fim = null
          filter.filterData.evento_id = null
          filter.filterData.ident_prest = null
          filter.filterData.evento_id = []
          break;
        case 'identNaOperadoraFilter':
           filter.filterData.login_valido = false
          break;
        case 'pagamentosPublicados':
          // filter.filterData.mes_corrente = opcoes.status? true : false
          filter.filterData.dt_inicio = null
          filter.filterData.dt_fim = null
          filter.filterData.nota_fiscal = null
          filter.filterData.powerFilter = false
          break;
        case 'pagamentosEmProcessamento':
          filter.filterData.evento_id = []
          filter.filterData.data_ate = null
          filter.filterData.data_entre = null
          break; 
        default:
          break;
      }
      this.$store.commit('recebiveis/setFilter', filter, { root:true })
    },
    modalVideo(){
      let paramModal = {
          codigo: "754809982",
          title: "Acesso ao recebíveis",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },

    modalVideoCadastro(){
      let paramModal = {
          codigo: "754810024",
          title: "Como editar acesso ao portal das operadoras",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },

    modalVideoProcessos(){
      let paramModal = {
          codigo: "754810047",
          title: "Acompanhamento do monitoramento operadoras",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },

    modalVideoPagamentos(){
      let paramModal = {
          codigo: "754810082",
          title: "Pagamentos em Processamento",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },

    modalVideoPubliados(){
      let paramModal = {
          codigo: "754810116",
          title: "Publicados no mês corrente: entenda os tipos de arquivos",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },

    modalVideoQuitar(){
      let paramModal = {
          codigo: "754810187",
          title: "Como quitar o pagamento",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },

    modalVideoGlosa(){
      let paramModal = {
          codigo: "754810239",
          title: "Recurso de glosa: tipos de envios e status",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
    temPermissaoCarteira(){
          this.$store.dispatch("recebiveis/verificaPermissaoCarteiras").then(resp => this.filtrarPorCarteiras = resp)
        },
    getDashboard(filter) {
        this.filter = filter
        let payload = filter? filter : { grupo_economico: this.grupoEconomico }
        let obj = {
            query: [
                {
                    Modulo: "Recebiveis",
                    Acao: "getdashboardpagamento",
                    Payload: payload,
                },
            ],
        }
        this.$store.dispatch("request/doRequest", obj).then((response) => {
            if (!response || response.isAxiosError || response.error) {
            this.$store.commit("hideLoader")
            return
            }
            this.cards.forEach(card=>{
              this[card] = response[card]? response[card] : null
            })
        })
    },
  },
}
</script>

<style>
#payment-monitor .title-text {
  font-size: 11px;
  line-height: 16px;
}
</style>